import React, { useEffect, useState } from 'react';
import { RequestManager } from '../Requests/RequestManager';
import TransformHome from '../Transformer/TransformHome';
import './Career.css';
import Background from '../Home/Media/Layer_2.png';
import Blog from '../Home/Blog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AxiosInstance } from '../Axios/Axios';

function Career() {
    const [career, setCareer] = useState({});
    const [loading, setLoading] = useState(true);
    const [sub, setSub] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        country: '',
        description: '',
        cv: '',
    });

    useEffect(() => {
        const init = async () => {
            try {
                const res = await RequestManager.fetchCareer();
                setCareer(TransformHome(res?.data) ?? {});
                setLoading(false);
            } catch (err) {
                console.error("Error in fetching data for careers: ", err);
                setError(err);
            }
        };
        init();
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: files ? files[0] : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSub(true);

        const formDataWithFile = new FormData();

        // Log the form data to check if values are populated
        console.log("Form Data:", formData);

        // Add the form data as a string to the FormData object
        formDataWithFile.append('data', JSON.stringify({
            Name: formData.name,
            Email: formData.email,
            Phone: formData.phone,
            Country: formData.country,
            Description: formData.description,
        }));

        // Check if there's a file to upload and add it to FormData
        if (formData.cv) {
            console.log('CV file:', formData.cv);
            formDataWithFile.append('files.CV', formData.cv);
        }

        try {
            const response = await AxiosInstance.post('/api/applies?populate=*', formDataWithFile, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            // Log the API Response to inspect
            console.log('API Response:', response);

            const applicationId = response.data?.data?.id;
            console.log('Application ID:', applicationId);

            if (response.status === 200 || response.status === 201) {
                toast.success('Form submitted successfully!');

                if (applicationId) {
                    // Fetch the newly created application data after the form submission
                    const result = await AxiosInstance.get(`/api/applies/${applicationId}?populate=*`);
                    console.log('Fetched result:', result.data);

                    // Fetch CV data after the submission
                    const cvData = result.data?.data?.attributes?.CV?.data;
                    if (cvData) {
                        console.log('CV found:', cvData);
                        await sendEmail(formData, cvData);
                    } else {
                        console.error("CV not found in the response.");
                    }
                } else {
                    console.error('Application ID missing from response.');
                }
            } else {
                toast.error('Failed to submit form with file!');
            }
        } catch (error) {
            console.error("Error submitting form:", error.response?.data || error.message);
            toast.error(error.response?.data?.error?.message || 'Error submitting form!');
        } finally {
            setSub(false);
        }
    };

    const sendEmail = async (formData, cvData) => {
        // Log the email data to check it's populated correctly
        console.log('Sending email with data:', formData);

        const emailContent = `
            Name: ${formData.name || 'Not provided'}
            Email: ${formData.email || 'Not provided'}
            Phone: ${formData.phone || 'Not provided'}
            Country: ${formData.country || 'Not provided'}
            Description: ${formData.description || 'Not provided'}
            CV Link: ${cvData?.attributes?.url || 'No CV attached'}
        `;

        const emailData = {
            to: 'marc_b_salem@hotmail.com',
            from: 'info@encogroup.net',
            subject: 'New Application Form Submission',
            text: emailContent,
        };

        // Log email content before sending
        console.log('Email content:', emailData);

        // Send the email (assuming your email sending logic is set up)
        // Your email API or logic here to send the email
    };




    return (
        <div className='container-fluid'>
            <div className="row">
                <div className="col-12 d-flex align-items-center">
                    <div className="row">
                        <div className="col-12 text-center">
                            {loading && <p>Loading...</p>}
                            {error && <p className="text-danger">Error: {error}</p>}
                        </div>
                    </div>
                </div>
            </div>
            {!loading && !error && (
                <div className="container-fluid px-0">
                    <div className="row bg-dark">
                        <div className="col-12 Main d-flex align-items-center"
                            style={{
                                backgroundImage: `url(${process.env.REACT_APP_API_URL}${career.HeroMedia})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center bottom',
                                backgroundRepeat: 'no-repeat',
                                width: '100%',
                                fontSize: 'var(--Title)',
                                color: 'white',
                            }}>
                            <div className="container" style={{ maxWidth: '90vw' }}>
                                <div className="row">
                                    <div className="col-12">
                                        <strong>CAREER</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="container" style={{ maxWidth: '90vw' }}>
                            <div className="row">
                                <div className="col-12 text-center my-5" style={{
                                    fontSize: 'var(--Regular)',
                                    color: 'var(--grey)'
                                }}>
                                    {career.Description}
                                </div>
                            </div>
                            <div className="row py-5">
                                <form onSubmit={handleSubmit}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 col-md-6 mt-5">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <label htmlFor="name">Name*</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <input type="text" name='name' className='w-100' required onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 mt-5">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <label htmlFor="phone">Phone Number*</label>
                                                    </ div>
                                                    <div className="col-12">
                                                        <input type="tel" name='phone' className='w-100' required onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 mt-5">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <label htmlFor="email">Email*</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <input type="email" name='email' className='w-100' required onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 mt-5">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <label htmlFor="country">Country*</label>
                                                    </div>
                                                    <div className="col-12">
                                                        <input type="text" name='country' className='w-100' required onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-5">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <textarea rows={5} name='description' placeholder='Description' className='w-100' required onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-auto mt-5 d-flex align-items-center justify-content-center">
                                                {sub ? (
                                                    <>Loading...</>
                                                ) :

                                                    <input type="submit" name="submit" style={{
                                                        backgroundColor: 'var(--primary)',
                                                        color: 'white',
                                                        borderRadius: '50px',
                                                        padding: '10px 20px',
                                                        fontWeight: 'bold'
                                                    }} />
                                                }
                                            </div>
                                            <div className="col-auto mt-5 d-flex align-items-center justify-content-center">
                                                <div className="row ">
                                                    <div className="col-auto d-flex flex-column align-items-center justify-content-center" style={{ fontSize: 'var(--Regular)', color: 'var(--primary)' }}>
                                                        <label htmlFor="cv" className="file-upload-label">
                                                            <svg width="38" height="37" viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clipPath="url(#clip0_187_1734)">
                                                                    <path d="M36.0695 20.4213C35.0029 20.4213 34.1377 21.2666 34.1377 22.3102V28.513C34.1377 31.1088 31.9791 33.2209 29.326 33.2209H8.67268C6.01965 33.2209 3.86231 31.1088 3.86231 28.513V22.3102C3.86231 21.2666 2.99836 20.4213 1.93179 20.4213C0.865229 20.4213 0 21.2666 0 22.3102V28.513C0 33.1922 3.89035 36.9999 8.67268 36.9999H29.326C34.1084 36.9999 38 33.1922 38 28.513V22.3102C38 21.2666 37.136 20.4213 36.0695 20.4213Z" fill="#1B7A99" />
                                                                    <path d="M10.9014 11.2785C11.3767 11.2785 11.8546 11.1065 12.2279 10.7611L17.0676 6.28013V26.7551C17.0676 27.7986 17.9316 28.6452 18.9994 28.6452C20.0673 28.6452 20.9312 27.7999 20.9312 26.7551V6.27888L25.7709 10.7599C26.1442 11.1052 26.6221 11.2773 27.0974 11.2773C27.6097 11.2773 28.1206 11.0791 28.5004 10.6863C29.2331  9.92826 29.1999 8.73258 28.4252 8.01442L20.3259 0.517421C20.3145 0.507447 20.303 0.498719 20.2915 0.488745C20.275 0.473784 20.2584 0.458822 20.2418 0.445107C20.2278 0.432639 20.2125 0.421418 20.1972 0.410197C20.1781 0.395235 20.159 0.38152 20.1399 0.367806C20.1233 0.355338 20.1068 0.344116 20.0902 0.331648C20.0749 0.320427 20.0583 0.3117 20.0418 0.300478C20.0201 0.286764 19.9997 0.274296 19.9781 0.261828C19.9628 0.2531 19.9475 0.243126 19.9309 0.234398C19.9131 0.224424 19.8952 0.215696 19.8761 0.206969C19.8532 0.195747 19.8302 0.184526 19.8073 0.174552C19.7933 0.168318 19.7793 0.160837 19.764 0.154603C19.7436 0.145875 19.7219 0.138395 19.7015 0.129667C19.6786 0.120939 19.6557 0.112212 19.6327 0.104731C19.6327 0.104731 19.6315 0.104731 19.6302 0.104731C19.6174 0.100991 19.6047 0.0947567 19.592 0.0910163C19.569 0.0835355 19.5448 0.0773015 19.5219 0.0710675C19.5002 0.0648335 19.4773 0.0598463 19.4556 0.0548591C19.4531 0.0548591 19.4518 0.0548591 19.4492 0.0536123C19.4365 0.0511187 19.425 0.0473784 19.4123 0.0448848C19.3881 0.0398976 19.3626 0.0349104 19.3384 0.03117C19.3167 0.0274296 19.2938 0.024936 19.2721 0.0211956C19.2568 0.018702 19.2403 0.0162084 19.225 0.0137148C19.2008 0.0112212 19.1765 0.00872759 19.1511 0.00748079C19.1307 0.00623399 19.109 0.00498719 19.0886 0.0037404C19.0695 0.0037404 19.0517 0.0012468 19.0325 0.0012468C19.0198 0.0012468 19.0083 0 18.9956 0C18.9829 0 18.9714 0.0012468 18.9599 0.0012468C18.9421 0.0012468 18.923 0.0024936 18.9051 0.0037404C18.8847 0.0037404 18.8631 0.00498719 18.8427 0.00748079C18.8172 0.00997439 18.793 0.0112212 18.7675 0.0137148C18.7522 0.0149616 18.7369 0.018702 18.7216 0.0199488C18.7 0.0224424 18. 6783 0.0261828 18.6566 0.0299232C18.6312 0.0349104 18.6057 0.0386508 18.5802 0.043638C18.57 0.0461316 18.5611 0.0486251 18.5509 0.0511187C18.5458 0.0523655 18.5407 0.0536123 18.5356 0.0548591C18.5152 0.0598463 18.4935 0.0648335 18.4731 0.0710675C18.4489 0.0773015 18.4234 0.0847823 18.3992 0.0922631C18.3903 0.0947567 18.3814 0.0984971 18.3725 0.102237C18.3674 0.103484 18.3623 0.105978 18.3572 0.107225C18.3355 0.114705 18.3139 0.122186 18.2922 0.129667C18.2705 0.138395 18.2476 0.145875 18.2259 0.15585C18.2119 0.162084 18.1992 0.169565 18.1852 0.175799C18.1622 0.185773 18.1406 0.195747 18.1189 0.206969C18.0998 0.216943 18.0794 0.225671 18.0616 0.235645C18.0463 0.244373 18.0322 0.2531 18.017 0.261828C17.9953 0.274296 17.9749 0.286764 17.9545 0.299232C17.938 0.310453 17.9201 0.320427 17.9035 0.331648C17.887 0.34287 17.8717 0.354091 17.8564 0.366559C17.8373 0.380274 17.8182 0.393988 17.7991 0.40895C17.7838 0.421418 17.7685 0.432639 17.7532 0.445107C17.7366 0.458822 17.7213 0.473784 17.7048 0.487498C17.6933 0.497473 17.6818 0.5062 17.6704 0.516175L9.57237 8.01567C8.79761 8.73258 8.76448 9.92826 9.49719 10.6876C9.87692 11.0803 10.3879 11.2785 10.9002 11.2785H10.9014Z" fill="#1B7A99" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_187_1734">
                                                                        <rect width="38" height="37" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                            <input type="file" id="cv" name="cv" className="file-upload-input" required onChange={(e) => setFormData({ ...formData, cv: e.target.files[0] })} />
                                                        </label>
                                                        Upload resume<br />
                                                        <span style={{ color: 'var(--grey)', fontSize: '10px' }}>
                                                            PDF, DOC, DOCX (5M)
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="row mt-5">
                                <div className="col-lg-5 col-12 d-flex align-items-center justify-content-center" style={{
                                    backgroundImage: `url(${Background})`,
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'left center',
                                    backgroundRepeat: 'no-repeat',
                                    fontSize: 'var(--subTitle)',
                                    color: 'var(--primary)'
                                }}>
                                    <div className="row">
                                        <div className="col-12">
                                            <strong>WHAT'S<br /></strong>
                                            <span style={{ fontSize: 'var(--Title)', fontWeight: 'lighter' }}>
                                                NEW
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-12">
                                    <Blog />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </div>
    );
}

export default Career;